import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { UserIcon } from '@heroicons/react/24/outline';

const Avatar = memo(({ url, size = 'md', alt = 'Avatar', onError, onLoad }) => {
  const [imageError, setImageError] = useState(false);
  const [key, setKey] = useState(Date.now());

  useEffect(() => {
    setImageError(false);
    setKey(Date.now());
  }, [url]);

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-32 h-32',
  };

  const sizeIconClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-16 h-16',
  };

  if (!url || imageError) {
    return (
      <div 
        className={`${sizeClasses[size]} rounded-full bg-slate-800 flex items-center justify-center border-2 border-slate-700`}
      >
        <UserIcon className={`${sizeIconClasses[size]} text-slate-500`} />
      </div>
    );
  }

  const getFullUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('data:') || path.startsWith('http') || path.startsWith('blob:')) {
      return path;
    }
    return `${API_BASE_URL}/${path}`;
  };

  const imageUrl = `${getFullUrl(url)}?v=${key}`;

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full overflow-hidden bg-slate-800 border-2 border-slate-700`}
    >
      <img
        src={imageUrl}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          setImageError(true);
          onError?.(e);
        }}
        onLoad={(e) => {
          onLoad?.(e);
        }}
      />
    </div>
  );
});

Avatar.propTypes = {
  url: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  alt: PropTypes.string,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
};

export default Avatar;
